export const ZENDESK_HELP_CENTER_URL = {
  API_KEY:
    'https://support.zendesk.com/hc/en-us/articles/4408889192858-Managing-access-to-the-Zendesk-API',
  BRAND_ID:
    'https://support.zendesk.com/hc/en-us/articles/6606906179098-How-can-I-identify-brand-IDs-in-a-multi-brand-setup',
  API_SUBDOMAIN:
    'https://support.zendesk.com/hc/en-us/articles/4409381383578-Where-can-I-find-my-Zendesk-subdomain',
  API_TOKEN:
    'https://support.zendesk.com/hc/en-us/articles/4408889192858-Managing-API-token-access-to-the-Zendesk-API',
};

export const FRESHDESK_URL = {
  WHERE_CAN_FIND_API_KEY:
    'https://support.freshdesk.com/support/solutions/articles/225435-where-can-i-find-my-api-key-',
  HOW_TO_FIND_YOUR_API_KEY:
    'https://support.freshdesk.com/support/solutions/articles/215517-how-to-find-your-api-key',
};

export const COSUPPORT_URL = {
  REQUEST_DEMO: 'https://cosupport.ai/demo',
  PRIVACY: 'https://cosupport.ai/privacy',
  TERMS_OF_SERVICES: 'https://cosupport.ai/terms-of-services',
};

export const SETUP_GUIDE_URL = {
  ZENDESK_CHAT:
    'https://www.notion.so/cosupport/Launching-CoCustomer-for-Zendesk-Web-Widget-2021fff62e4680f5aef3c359b7de0505',
  ZENDESK_EMAIL:
    'https://www.notion.so/cosupport/Launching-CoCustomer-for-Zendesk-Email-2021fff62e46805dacc6dbdd9e117ed8',
  FRESHDESK_EMAIL:
    'https://www.notion.so/cosupport/Launching-CoSupport-AI-Agent-with-Freshdesk-Email-2021fff62e4680b19cf6f9eaee7d2051',
  FRESHCHAT:
    'https://www.notion.so/cosupport/Launching-CoSupport-AI-Agent-with-Freshchat-Web-Widget-2881fff62e4680c88a06ffff16358c50',
  ZOHODESK_EMAIL:
    'https://www.notion.so/cosupport/Integration-with-Zoho-Desk-2021fff62e4680d1ba60f6b4a67f6f47',
  ZOHO_SALES_IQ:
    'https://www.notion.so/cosupport/Integration-with-Zoho-SalesIQ-2021fff62e46802eaf93e70f0fa36249',
};

export const GOOGLE_URL = {
  STORAGE: 'https://storage.googleapis.com',
};
